var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.8 5.73a9.028 9.028 0 0 1-2.552.718 4.498 4.498 0 0 0 1.948-2.51c-.855.523-1.8.893-2.808 1.1A4.387 4.387 0 0 0 16.154 3.6c-2.452 0-4.425 2.04-4.425 4.543 0 .36.03.706.102 1.036-3.681-.185-6.939-1.994-9.127-4.751a4.662 4.662 0 0 0-.606 2.296 4.58 4.58 0 0 0 1.967 3.774 4.29 4.29 0 0 1-2.001-.56v.05c0 2.208 1.535 4.04 3.548 4.463a4.32 4.32 0 0 1-1.161.15 3.82 3.82 0 0 1-.839-.078c.574 1.799 2.202 3.121 4.138 3.164a8.757 8.757 0 0 1-5.49 1.937c-.363 0-.712-.016-1.06-.062A12.241 12.241 0 0 0 7.993 21.6c8.149 0 12.604-6.923 12.604-12.924 0-.2-.007-.395-.017-.587A8.962 8.962 0 0 0 22.8 5.73Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.ff62a1fae55b80fd20f39a86a3357098.svg";
export { ForwardRef as ReactComponent };